import CustomerServicePortraitComponent from './component';

class CustomerServicePortraitRoute extends CustomerServicePortraitComponent {
    asyncModel() {
        return {};
    }
}

export default CustomerServicePortraitRoute;
